import { render, staticRenderFns } from "./RecountVisualRemote__dnDeshifResults.vue?vue&type=template&id=1fc20c82&scoped=true&"
import script from "./RecountVisualRemote__dnDeshifResults.vue?vue&type=script&lang=js&"
export * from "./RecountVisualRemote__dnDeshifResults.vue?vue&type=script&lang=js&"
import style0 from "@/style/wrapper.css?vue&type=style&index=0&id=1fc20c82&scoped=true&lang=css&"
import style1 from "@/style/grid.css?vue&type=style&index=1&id=1fc20c82&scoped=true&lang=css&"
import style2 from "@/style/input.css?vue&type=style&index=2&id=1fc20c82&scoped=true&lang=css&"
import style3 from "./RecountVisualRemote__dnDeshifResults.vue?vue&type=style&index=3&id=1fc20c82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc20c82",
  null
  
)

export default component.exports